import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StockResponse} from '../models/stock-response.model';
import {DemoVehiclesRequest} from '../models/demo-request.model';
import {SelectListOption} from '@bmw-ds/components';
import {environment} from '../../environments/environment';
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root',
})
export class DemoService {
    constructor(private readonly http: HttpClient,
                private authService: AuthService) {
    }

    private getHeaders(): HttpHeaders {
        const token = this.authService.getAccessToken() || '';
        const host = window.location.hostname.toLowerCase();
        const domainExt = host.match(/\.(com|net)/)?.[0] || '';
        const domainStr = domainExt === '.com' ? 'com' : 'net';

        let headers = new HttpHeaders()
            .set('Authorization', `${token}`)
            .set('domain', domainStr);

        return headers;
    }

    getDemoVehicles(
        requestPayload: DemoVehiclesRequest
    ): Observable<StockResponse> {
        const url = '/replenishment/demo-vehicles';
        return this.http.post<StockResponse>(url, requestPayload, {headers: this.getHeaders()});
    }

    getPurposeDropdown(): Observable<SelectListOption[]> {
        const url = '/replenishment/purpose';
        return this.http.get<SelectListOption[]>(url, {headers: this.getHeaders()});
    }
}
